import React from 'react';
import PropTypes from 'prop-types';
import './FeaturedProfilesCarousel.scss';
import divider from '../../../assets/images/rectangle.svg';

function FeaturedProfilesCarouselCard({
  image, title, text, source, link,
}) {
  return (
    <div className="carousel-card">
      <div>
        <img
          className="d-block w-100 carousel-image"
          src={image}
          alt={title}
        />
      </div>
      <div>
        <img className="rectangle" src={divider} alt="" />
        <p className="carousel-text carousel-title">{title}</p>
        <p className="carousel-text carousel-body">{text}</p>
        {link
          ? (
            <a href={link} target="_blank" rel="noopener noreferrer">
              <button className="btn btn-primary">{source}</button>
            </a>
          )
          : <p className="carousel-text carousel-text-source">{source}</p>}
      </div>
    </div>
  );
}

FeaturedProfilesCarouselCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  link: PropTypes.string,
};

FeaturedProfilesCarouselCard.defaultProps = {
  link: null,
};

export default FeaturedProfilesCarouselCard;
